<template>
    <section class="contacts">
        <section class="contacts__header d-flex justify-content-between align-items-baseline gap-3">
            <h1 class="contacts__title">{{$t('com.file.nav-data.contacts')}}</h1>
            <LicensesInfoComponent />
            <section class="contact-top__action-buttons">
                <ButtonToolbar>
                    <ButtonGroup>
                        <ButtonBasic color="danger"
                                     v-if="adminMenagePrivilige && adminContactPrivilige"
                                     @click="() => $store.commit('isImportContactModalStatus', true)"
                                     size="lg"
                                     v-tooltip="$t('com.file.contacts.import-contacts')">
                            <ButtonIcon icon="users-medical" />
                        </ButtonBasic>
                        <ButtonSeparator />
                        <!--<ButtonBasic color="danger"
                                 v-if="adminMenagePrivilige && adminContactPrivilige && adminMainPrivilige"
                                 @click="getLogins()"
                                 size="lg"
                                 v-tooltip="'Pobierz dane logowania nowo dodanych radnych'">
                        <ButtonIcon icon="download" />
                    </ButtonBasic>-->
                        <ButtonSeparator />
                        <ButtonBasic color="danger"
                                     v-if="adminMenagePrivilige && adminContactPrivilige && adminNfcModule"
                                     @click="$store.commit('setNfcAssigmentModalStatus', true)"
                                     size="lg"
                                     v-tooltip="$t('com.file.contacts.nfc-person-assigments')">
                            <ButtonIcon icon="nfc-signal" />
                        </ButtonBasic>
                        <ButtonSeparator />
                        <ButtonSeparator />
                        <ButtonBasic color="danger"
                                     v-if="adminMenagePrivilige && adminContactPrivilige"
                                     @click="(e) => handleChangeView(e, 'add-group')"
                                     size="lg"
                                     v-tooltip="$t('com.file.contacts.add-group')">
                            <ButtonIcon icon="add-group" />
                        </ButtonBasic>
                        <ButtonSeparator />
                        <ButtonSeparator />
                        <ButtonBasic color="danger"
                                     v-if="adminMenagePrivilige && adminContactPrivilige"
                                     @click="(e) => handleChangeView(e, 'add-contact')"
                                     size="lg"
                                     v-tooltip="$t('com.file.contacts.add-contact')">
                            <ButtonIcon icon="add-contact" />
                        </ButtonBasic>

                        <ButtonSeparator />
                        <ButtonSeparator />
                        <ButtonBasic color="danger"
                                     v-if="adminMenagePrivilige && adminContactPrivilige"
                                     @click="exportContacts"
                                     size="lg"
                                     v-tooltip="$t('com.file.contacts.export-contacts')">
                            <ButtonIcon icon="download" />
                        </ButtonBasic>
                    </ButtonGroup>
                </ButtonToolbar>
            </section>
        </section>

        <section class="contact-top">
            <section class="contact-top__search d-flex flex-wrap flex-row gap-3">
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.session-search.search-pharse')" />
                    <SearchInputTextComponent v-model="searchCriteria.searchText" :placeholder="$t('com.file.contacts.search-contact')" :disabled="isFiltering" ref="searchInput" />
                </section>
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.contacts.search-privileges')" />
                    <Multiselect v-model="searchCriteria.priviliges"
                                :placeholder="$t('com.file.contacts.select-privileges')"
                                mode="multiple"
                                :close-on-select="true"
                                class="contact-top__search__multisearch"
                                :searchable="true"
                                :create-option="false"
                                :object="true"
                                :options="filters.availablePrivileges"
                                :noResultsText="$t('com.global.no-results')"
                                :noOptionsText="$t('com.global.no-options')">
                                <template v-slot:multiplelabel="{ values }">
                                    <div class="multiselect-multiple-label" v-if="values.length == 1">
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.contacts.privilege')}}
                                    </div>
                                    <div class="multiselect-multiple-label" v-else-if="values.length >= 2 && values.length < 5">
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.contacts.privileges')}}
                                    </div>
                                    <div class="multiselect-multiple-label" v-else>
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.contacts.privilege2')}}
                                    </div>
                            </template>
                        </Multiselect>
                </section>
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.contacts.search-groups')" />
                    <Multiselect v-model="searchCriteria.groups"
                                :placeholder="$t('com.file.contacts.select-groups')"
                                mode="multiple"
                                :close-on-select="true"
                                class="contact-top__search__multisearch"
                                :searchable="true"
                                :create-option="false"
                                :object="true"
                                :options="filters.availableGroups"
                                :noResultsText="$t('com.global.no-results')"
                                :noOptionsText="$t('com.global.no-options')">
                                <template v-slot:multiplelabel="{ values }">
                                    <div class="multiselect-multiple-label" v-if="values.length == 1">
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.add-group.group')}}
                                    </div>
                                    <div class="multiselect-multiple-label" v-else-if="values.length >= 2 && values.length < 5">
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.session-search.groups')}}
                                    </div>
                                    <div class="multiselect-multiple-label" v-else>
                                        {{$t('com.file.session-search.checked')}}&nbsp;<strong>{{ values.length }}</strong>&nbsp;{{$t('com.file.session-search.groups2')}}
                                    </div>
                            </template>
                    </Multiselect>
                </section>
            </section>
        </section>
        <section class="contact__current-filters d-flex flex-wrap flex-row gap-2 pb-3">
            <SearchFilterItem v-if="searchCriteria.searchText !== ''" 
                                :prepend="$t('com.file.session-search.search-pharse') + ':'" 
                                :value="searchCriteria.searchText" 
                                @remove="() => { searchCriteria.searchText = ''}"/>

            <SearchFilterItem v-for="(item, index) in searchCriteria.priviliges"
                                      :key="index"
                                      :prepend="$t('com.file.contacts.select-privileges') + ':'"
                                      :value="item.label"
                                      :identifier="item.value"
                                      @remove="(id) => searchCriteria.priviliges = searchCriteria.priviliges.filter(el => el.value !== parseInt(id))" />

            <SearchFilterItem v-for="(item, index) in searchCriteria.groups"
                                      :key="index"
                                      :prepend="$t('com.file.contacts.select-groups') + ':'"
                                      :value="item.label"
                                      :identifier="item.value"
                                      @remove="(id) => searchCriteria.groups = searchCriteria.groups.filter(el => el.value !== parseInt(id))" />

        </section>
        <section class="contacts__list" v-if="availableGroups.length > 0">
            <ContactList :groups="availableGroups"
                         :addContactHandler="handleChangeView"
                         :menageGroupPriviligesHandler="handleMenageGroups"
                         :sendSmsHandler="handleSendSms"
                         :sendEmailHandler="handleSendEmail"
                         :searchBar="searchText"
                         @reloadGroups="refreshGroups" />

            <button v-if="adminMenagePrivilige && adminContactPrivilige" v-tooltip="$t('com.file.contacts.add-contact')"
                    class="contacts__add-user-btn"
                    @click="(e) => handleChangeView(e, 'add-contact')">
                <img src="../../../../assets/icons/components/add-contact.svg"
                     class="contacts__add-user-btn-icon" />
            </button>

            <button v-if="adminMenagePrivilige && adminContactPrivilige && $store.state.contacts.selectedPeopleToSendMessage.length > 0" v-tooltip="$t('com.file.contacts.send-email-to-selected')"
                    class="contacts__send-message-btn" style="margin-right: 80px;"
                    @click="() => handleSendEmail( 3, null, null, null)">
                <img src="../../../../assets/icons/components/send-mail-white.svg"
                     class="contacts__send-message-btn-icon" />
            </button>

            <button v-if="adminMenagePrivilige && adminContactPrivilige && $store.state.contacts.selectedPeopleToSendMessage.length > 0" v-tooltip="$t('com.file.contacts.send-sms-to-selected')"
                    class="contacts__send-message-btn" style="margin-right: 160px;"
                    @click="() => handleSendSms( 3, null, null, null)">
                <img src="../../../../assets/icons/components/send-sms-white.svg"
                     class="contacts__send-message-btn-icon" />
            </button>

        </section>
        <section v-else class="contact-list-no-result">{{$t('com.file.contacts.no-groups')}}</section>
        <section v-if="currentView !== 'none'">
            <AddContact :groups="groups"
                        v-if="currentView === 'add-contact'"
                        :handler="handleChangeView"
                        @renewGroups="(groups)=>{ this.groups = groups; this.groupsSearch = this.groups.map(a => { return { ...a } }); this.searchBar = ''; this.internalRefreshSearch(this.searchCriteria);}"
                        :storedGroupId="storedGroupId" :storedUserEditData="storedUserEditData" />

            <AddGroup v-if="currentView === 'add-group'"
                      :handler="handleChangeView"
                      :storedGroupData="storedGroupData"
                      @setGroups="(groups) => (this.groups = groups)"
                      @reloadGroups="refreshGroups" />
        </section>

        <Transition>
            <GroupAccessAdminsModal v-if="showGroupManageAdminModal && adminMainPrivilige" @closeGroupManageAdminModal="closeGroupManageAdminModal" @refreshGroups="refreshGroups" :options="adminsOptions" :selected="selectedAdmins" :groupData="tempGroupData"  />
        </Transition>

        <Transition>
            <SMSModal v-if="showSMSModal" @close="closeSMSModal" :options="smsOptions" :selected="selected" />
        </Transition>

        <Transition>
            <EmailModal v-if="showEmailModal" @closeEmail="closeEmailModal" :options="emailOptions" :selected="selectedEmail" />
        </Transition>

        <Transition>
            <ImportContactModal v-if="isImportContactModal" @refreshGroups="refreshGroups" />
        </Transition>

        <Transition>
            <NfcAssigmentModal v-if="isNfcAssigmentModalStatus" @refreshGroups="refreshGroups" />
        </Transition>
    </section>
</template>

<script charset="utf-8">
    import SearchFilterItem from '@/components/BasicControls/SearchFilterItem.vue';
    import SearchLabelComponent from "../../../BasicControls/SearchLabelComponent.vue"
    import Multiselect from '@vueform/multiselect'
    import ContactService from "../../../../services/contact.service";
    import { encryptStorage } from '../../../../services/encrypt.service';
    //import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
    import ContactList from "./ContactList/ContactList.vue";
    import AddContact from "./Modals/AddContact/AddContact.vue";
    import AddGroup from "./Modals/AddGroup/AddGroup.vue";
    import AlertHelper from '@/helpers/alerts.helper.js';
    import SearchInputTextComponent from "../../../BasicControls/SearchInputTextComponent.vue";
    import LicensesInfoComponent from "./Modals/Infos/LicensesInfo.vue";
    import SMSModal from "../Home/Modals/SendSMS.vue";
    import EmailModal from "../Home/Modals/SendEmail.vue";
    import ImportContactModal from "./Modals/AddContact/ImportContactModal.vue";
    import GroupAccessAdminsModal from "./Modals/GroupsAccess/GroupAccessAdminsModal.vue";
    import NfcAssigmentModal from "./Modals/AddContact/NfcAssigmentModal.vue";
    import alertsHelper from "@/helpers/alerts.helper";
    import { fileDownloadHelper } from "@/helpers/file.download.helper";

    export default {
        name: "contact",
        data() {
            return {
                searchText: "",
                searchBar: "",
                groups: [],
                adminsOptions: [],
                selectedAdmins: [],
                groupsSearch: [],
                currentView: "none",
                storedGroupId: null,
                storedUserEditData: {},
                storedGroupData: {},
                adminContactPrivilige: encryptStorage.getItem("priv").komunikator,
                adminMainPrivilige: encryptStorage.getItem("priv").uprawnienia,
                adminMenagePrivilige: encryptStorage.getItem("priv").zarzadzanie_kontaktami,
                adminNfcModule: encryptStorage.getItem("modules").nfc,
                selected: [],
                smsOptions: [],
                showSMSModal: false,
                showGroupManageAdminModal: false,
                selectedEmail: [],
                emailOptions: [],
                showEmailModal: false,
                isFiltering: false,
                tempGroupData: {
                    id: 0,
                    name: ''
                },
                searchCriteria: {
                    searchText: "",
                    priviliges: [],
                    groups: []
                },
                availableGroups: [],
                filters: {
                    availableGroups: [],
                    availablePrivileges: []
                }
            };
        },
        computed: {
            searchPeopleId() {
                if (this.$route.query.searchPeopleId === undefined || this.$route.query.searchPeopleId === null) {
                    return -1;
                }
                return this.$route.query.searchPeopleId;
            },
            isAnyModalOpen(){
                return this.showEmailModal
                    || this.showSMSModal
                    || this.currentView !== "none"
                    || this.isImportContactModal
                    || this.showGroupManageAdminModal
            },

            isImportContactModal() {
                return this.$store.state.appStore.importContactModalStatus;
            },
            isNfcAssigmentModalStatus(){
                return this.$store.state.appStore.nfcAssigmentModalStatus;
            }
        },
        watch: {
            searchPeopleId: {
                deep: true,
                handler: function (newValue) {
                    try {
                        if (parseInt(newValue) === -1) {
                            return;
                        }
                        this.prepareEditContact(newValue);
                    }
                    catch (e) {
                        console.warn(e);
                    }
                    
                }
            },
            searchCriteria:{
                deep: true,
                handler: async function(internalCriteria){
                    try{
                        this.$store.commit("showLoader");
                        await this.internalRefreshSearch(internalCriteria)
                    }
                    finally{
                        this.isFiltering = false;
                        this.$store.commit("hideLoader");
                    }
                }
            },
            isAnyModalOpen: {
                deep: true,
                handler: function (val) {
                    document.querySelector('body').style.overflow = val ? 'hidden' : 'auto';
                }
            },
        },
        methods: {
            prepareEditContact(id) {
                this.$store.state.userStore.isLoading = true;
                ContactService.showUserData(id).then(
                    (response) => {
                        this.storedUserEditData = response.data;
                        this.storedUserEditData.groups =
                            this.storedUserEditData.groups.map(
                                (group) => group.id
                            );
                        this.$store.state.userStore.isLoading = false;
                        this.currentView = 'add-contact';
                    }
                );
            },
            async handleMenageGroups(groupId, groupName) {
                try {

                    if (!this.adminMainPrivilige)
                        return;

                    this.$store.commit("showLoader");

                    var result = (await ContactService.getAdminsForGroupManage(groupId)).data;
                    if (Object.keys(result).length > 0) {
                        this.adminsOptions = result;
                        this.selectedAdmins = this.adminsOptions.filter(x => x.access).map(x => x.id);
                        this.showGroupManageAdminModal = true;
                        this.tempGroupData = {
                            id: groupId,
                            name: groupName
                        };
                    }
                } catch (e) {
                    if (e.response.status === 401)
                        this.$router.push({ name: 'Login' })
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            async handleSendSms(type, groupId, personId, peoples) {
                try {
                    this.$store.commit("showLoader");
                    var result = (await ContactService.getUsersToSmsOrEmail(1)).data;
                    if (Object.keys(result).length > 0) {
                        this.selected = [];
                        this.smsOptions = result;
                        if (type == 1) {
                            // single
                            this.selected.push(personId);
                        }
                        else if (type == 2) {
                            // group
                            var group = this.smsOptions.filter(x => x.id == groupId);

                            if (group.length > 0) {

                                let people = group[0].options.map(x => x.value);

                                if (people.length > 0) {
                                    for (var i = 0; i < peoples.length; i++) {
                                        if (people.includes(peoples[i].id)) {
                                            this.selected.push(peoples[i].id);
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            // selected in group
                            var peopleListStore = this.$store.state.contacts.selectedPeopleToSendMessage;

                            if (peopleListStore.length > 0) {
                                for (var j = 0; j < this.smsOptions.length; j++) {
                                    let pl = this.smsOptions[j].options.map(x => x.value);
                                    for (var k = 0; k < peopleListStore.length; k++) {
                                        if (pl.includes(peopleListStore[k])) {
                                            if (!this.selected.includes(peopleListStore[k])) {
                                                this.selected.push(peopleListStore[k]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        this.showSMSModal = true;
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            async handleSendEmail(type, groupId, personId, peoples) {
                try {
                    this.$store.commit("showLoader");
                    var result = (await ContactService.getUsersToSmsOrEmail(2)).data;
                    if (Object.keys(result).length > 0) {
                        this.selectedEmail = [];
                        this.emailOptions = result;

                        if (type == 1) {
                            // single
                            this.selectedEmail.push(personId);
                        }
                        else if (type == 2) {
                            // group
                            var group = this.emailOptions.filter(x => x.id == groupId);

                            if (group.length > 0) {
                                let people = group[0].options.map(x => x.value);

                                if (people.length > 0) {
                                    for (var i = 0; i < peoples.length; i++) {
                                        if (people.includes(peoples[i].id)) {
                                            this.selectedEmail.push(peoples[i].id);
                                        }
                                    }
                                }
                            }

                        }
                        else {
                            // selected in group
                            var peopleListStore = this.$store.state.contacts.selectedPeopleToSendMessage;

                            if (peopleListStore.length > 0) {

                                for (var j = 0; j < this.emailOptions.length; j++) {
                                    let pl = this.emailOptions[j].options.map(x => x.value);
                                    for (var k = 0; k < peopleListStore.length; k++) {
                                        if (pl.includes(peopleListStore[k])) {
                                            if (!this.selectedEmail.includes(peopleListStore[k])) {
                                                this.selectedEmail.push(peopleListStore[k]);
                                            }    
                                        }
                                    }
                                }
                            }
                        }
                        this.showEmailModal = true;
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            closeGroupManageAdminModal() {
                this.showGroupManageAdminModal = false;
                this.adminsOptions = [];
                this.selectedAdmins = [];
                this.tempGroupData = {
                    id: 0,
                    name: ''
                };
            },
            closeSMSModal() {
                this.showSMSModal = false;
                this.smsOptions = [];
                this.selected = [];
                //this.$store.commit('setSelectedPeopleToSendMessage', []);
            },
            closeEmailModal() {
                this.showEmailModal = false;
                this.selectedEmail = [];
                this.emailOptions = [];
                //this.$store.commit('setSelectedPeopleToSendMessage', []);
            },
            handleSearchSubmit(e) {
                e.preventDefault();
            },
            handleChangeView(e, status, additionalData = { id: null, action: "none" }) {
                if (e !== null) {
                    e.preventDefault();
                }
                if (status === "none") {
                    this.storedGroupId = null;
                    this.storedUserEditData = {};
                    this.currentView = status;
                    this.storedGroupData = {};
                }

                if (additionalData.id !== null && additionalData.action === "add-contact-to-group") {
                    this.storedGroupId = additionalData.id;
                    this.currentView = status;
                }

                if (additionalData.id !== null && additionalData.action === "edit-contact") {
                    this.$store.state.userStore.isLoading = true;
                    ContactService.showUserData(additionalData.id).then(
                        (response) => {
                            this.storedUserEditData = response.data;
                            this.storedUserEditData.groups =
                                this.storedUserEditData.groups.map(
                                    (group) => group.id
                                );
                            this.$store.state.userStore.isLoading = false;
                            this.currentView = status;
                        }
                    );
                }

                if ( additionalData.id !== null && additionalData.action === "edit-group") {
                    this.$store.state.userStore.isLoading = true;
                    ContactService.showGroupData(additionalData.id).then(
                        (response) => {
                            this.storedGroupData = response.data;
                            this.$store.state.userStore.isLoading = false;
                            this.currentView = status;
                        }
                    );
                }

                if (additionalData.id === null) {
                    this.currentView = status;
                }
            },
            //async getLogins() {
            //    try {
            //        this.$store.commit("showLoader");
            //        let response = await ContactService.getUsersLoginDataToWord();
            //        if (response.status !== 200) {
            //            throw await Promise.reject(response)
            //        }

            //        const contentType = response.headers['content-type'];
            //        let a = document.createElement('a');
            //        var blob = new Blob([response.data], { 'type': contentType });
            //        a.href = window.URL.createObjectURL(blob);
            //        var filename = response.headers['content-disposition'].split("filename=")[1];

            //        filename = filename.substr(0, filename.indexOf(';'));
            //        filename = filename.replaceAll('"', '');
            //        a.download = filename
            //        a.click();
            //    }
            //    finally {
            //        this.$store.commit("hideLoader");
            //    }
            //},

            async refreshGroups() {
                try {
                    
                    let response = await ContactService.index(false);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }
                    await this.internalRefreshSearch(this.searchCriteria);
                    this.groups = response.data;
                    this.groupsSearch = this.groups.map(a => { return { ...a } });
                    this.$store.commit("setGroups", response.data);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },

            async internalFetchAvailablePrivileges(){
                try{
                    const result = await ContactService.getAvailablePrivileges();

                    if(result.status !== 200){
                        throw await Promise.reject(result);
                    }

                    const translatedPrivileges = result.data.map(item => ({
                        label: this.$t(item.label),
                        value: item.value
                    }));

                    this.filters.availablePrivileges = [...translatedPrivileges];

                    this.filters.availablePrivileges.sort((a,b) => (a?.label ?? '').localeCompare(b?.label ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));
                }
                catch(e){
                    console.log(e);
                }
            },
            async internalFetchAvailableGroups(){
                try{
                    const result = await ContactService.index(false);
                    if(result.status !== 200){
                        throw await Promise.reject(result);
                    }
                    this.$store.commit("setGroups", result.data);
                    this.filters.availableGroups = result.data.map(item => ({
                        label: item.name,
                        value: item.id
                    }))
                    .sort((a,b) => (a?.label ?? '').localeCompare(b?.label ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));
                }
                catch(e){
                    console.log(e);
                }
            },
            getSearchCriteria(data){
                const criteria = {...data};
                criteria.priviliges = data.priviliges.map(privilege => privilege.value)
                criteria.groups = data.groups.map(group => group.value)
                return criteria;
            },
            async internalRefreshSearch(data){
                try{
                    this.isFiltering = true;
                    
                    const criteria = this.getSearchCriteria(data);
                    const result  = await ContactService.searchContacts(criteria);
                    if(result.status === 200){
                        this.availableGroups = result.data.sort((a,b) => (a?.name ?? '').localeCompare(b?.name ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));
                    }
                }
                finally{
                    this.isFiltering = false;
                }
            },
            async exportContacts(){
                try{
                    this.$store.commit("showLoader")
                    
                    const criteria = this.getSearchCriteria(this.searchCriteria);
                    const result  = await ContactService.exportContacts(criteria);
                     if (result.status !== 200) {
                        throw await Promise.reject(result)
                    }

                    fileDownloadHelper(result);
                    this.$swal(alertsHelper.successAlert(this.$t('com.file.contacts.file-downloades-success'), this.$t('com.global.success')));
                }
                finally{
                    this.$store.commit("hideLoader")
                }
            }
        },
        components: {
            //ButtonWithIcon,
            SearchFilterItem,
            Multiselect,
            SearchLabelComponent,
            ContactList,
            AddContact,
            AddGroup,
            SearchInputTextComponent,
            LicensesInfoComponent,
            SMSModal,
            EmailModal,
            ImportContactModal,
            GroupAccessAdminsModal,
            NfcAssigmentModal
        },
        async mounted() {
            const result  = await ContactService.searchContacts(this.searchCriteria);
            if(result.status === 200){
                this.availableGroups = result.data
                .sort((a,b) => (a?.name ?? '').localeCompare(b?.name ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));
            }

            await this.internalFetchAvailablePrivileges(); 
            await this.internalFetchAvailableGroups();
            this.$store.commit('setSelectedPeopleToSendMessage', []);
            this.$store.commit('setSendMessageSuccess', false);

            if (parseInt(this.searchPeopleId) !== -1) {
                this.prepareEditContact(this.searchPeopleId);
            }

            if (this.adminContactPrivilige) {
                this.$store.commit("showLoader");
                ContactService.index(false).then((response) => {
                    this.groups = response.data;
                    this.groupsSearch = this.groups.map(a => { return { ...a } });
                    this.$store.commit("setGroups", response.data);
                    this.$store.commit("hideLoader");
                });
            }
            else {
                this.$swal(AlertHelper.errorAlert(this.$t('com.file.contacts.no-contact-module'), this.$t('com.global.error')));
                this.$router.push({ name: "home" });
            }
        },
    };
</script>

<style lang="scss" scoped>
    .contacts {
        margin: 49px 48px;

        &__title {
            font-weight: 600;
            font-size: 28px;
            line-height: 128%;
            color: #00082c;
            margin-bottom: 20px;
        }

        &__add-user-btn {
            position: fixed;
            bottom: 40px;
            right: 48px;
            width: 56px;
            height: 56px;
            border: 0px;
            background: #d80418;
            box-shadow: 8px 8px 28px rgba(173, 3, 19, 0.16);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2 ease-in-out;

            &:hover {
                background: #ad0313 !important;
            }
        }

        &__send-message-btn {
            position: fixed;
            bottom: 40px;
            right: 48px;
            width: 56px;
            height: 56px;
            border: 0px;
            background: #d80418;
            box-shadow: 8px 8px 28px rgba(173, 3, 19, 0.16);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2 ease-in-out;

            &:hover {
                background: #ad0313 !important;
            }
        }

        &__add-user-btn-icon {
            width: 25px;
            height: 24px;
        }

        &__send-message-btn-icon {
            width: 25px;
            height: 24px;
        }
    }

    .contact-top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        column-gap: 20px;

        &__input {
            height: 48px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
            border-radius: 4px;
            width: 326px;
            box-sizing: border-box;
            padding: 12.5px 16px;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-right: 0px;

            &:focus {
                border: 1px solid #00082c;
            }
        }

        &__button-search {
            height: 48px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            border-left: 0px;
            position: relative;
            cursor: pointer;

            &::after {
                content: "";
                position: absolute;
                width: 1px;
                height: 32px;
                background: #e2e5eb;
                top: 8px;
                left: 0px;
            }
        }

        &__form {
            display: flex;
            align-items: center;
        }

        &__search{
            &__multisearch{
                width: 300px;
                ::v-deep(.multiselect-search) {
                    height: 48px;
                    background: #ffffff;
                    border: 1px solid #d1d6df;
                    box-sizing: border-box;
                    box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08) !important;
                    border-radius: 4px;
                    box-sizing: border-box;
                    padding: 12.5px 16px;
                    border-right: 0px;
                }

                ::v-deep(.multiselect-placeholder){
                    color: rgb(117, 117, 117);
                    font-size: 0.85em;
                    padding-top: 4px;
                }

                ::v-deep(.multiselect-option > span){
                    font-size: 0.85em;
                }

                ::v-deep(.multiselect-multiple-label){
                    font-size: 0.85em;
                    padding-top: 4px;
                }

                ::v-deep(.multiselect-dropdown){
                    border-left: 1px solid #00082c !important;
                    border-right: 1px solid #00082c !important;
                    border-bottom: 1px solid #00082c !important;
                }
            }
        }

        &__search-icon {
            padding: 14px;
        }

        &__action-buttons {
            display: flex;
        }
    }
    .multiselect{
        border: none !important;
    }
    .multiselect.is-active{
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08) !important;
        border: 1px solid #00082c !important;
    }

    .contact-list-no-result {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn-without-text {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        border-radius: 4px;
        padding: 13.5px 32px;
        cursor: pointer;
        height: 46px;
        box-sizing: border-box;
        transition: all 0.2s ease-in-out;
        background-color: #ffffff;
        border: 1px solid #bbc2ce;
        background-color: #d80418;
        color: #ffffff;

        &:hover {
            background-color: #ad0313;
        }

        &__icon {
            width: 25px;
            height: 24px;
        }
    }

</style>
